// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ModuleSibling
 */
export interface ModuleSibling {
    /**
     * 
     * @type {string}
     * @memberof ModuleSibling
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleSibling
     */
    url: string;
}

export function ModuleSiblingFromJSON(json: any): ModuleSibling {
    return {
        'name': json['name'],
        'url': json['url'],
    };
}

export function ModuleSiblingToJSON(value?: ModuleSibling): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'url': value.url,
    };
}


